import { useEffect, useState } from "react";

/** Sets a useState with a true value after a given set of time */
export function useDelay(delayAmountMs: number, skipDelay = false) {
    const [delayFinished, setDelayFinished] = useState(skipDelay);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!skipDelay) {
                setDelayFinished(true);
            }
        }, delayAmountMs);

        return () => {
            clearTimeout(timeout);
        };
    }, []);

    return delayFinished;
}
